import { PropertyInformation, WaterInfo } from 'components/forms/TaxSearches/NJTaxSearch/types';
import WaterSewerInfo from 'components/forms/TaxSearches/NJTaxSearch/WaterSewer/WaterSewerInfo';
import { TrashCanIcon } from 'components/ui/icons';
import React from 'react';

interface PropTypes {
  waterIndex: number;
  w: WaterInfo;
  propertyInfo: PropertyInformation;
  expandedWaterIndex: number;
  toggleSectionExpanded: (key: number) => void;
  deleteWater: (key: number) => void;
  changeWater: (waterIndex: number, label: keyof WaterInfo, value: any) => void;
}

export const WaterFormBody = (props: PropTypes) => {
  return (
    <React.Fragment key={props.waterIndex}>
      <div style={{ backgroundColor: '#f5f5f5', padding: 16, marginTop: 16, borderRadius: 4 }}>
        <div
          style={{ display: 'flex', height: 50, justifyContent: 'space-between', cursor: 'pointer' }}
          onClick={() => props.toggleSectionExpanded(props.waterIndex)}
        >
          <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
            {props.w.type?.value || 'New Utility'}
          </div>
          <div
            style={{
              cursor: 'pointer',
              fontWeight: 'bold',
              marginTop: 'auto',
              marginBottom: 'auto',
            }}
          >
            <TrashCanIcon
              onClick={() => {
                props.deleteWater(props.waterIndex);
              }}
            />
          </div>
        </div>
        {props.expandedWaterIndex === props.waterIndex && (
          <>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                borderBottom: '2px solid white',
                marginBottom: 8,
                marginTop: 8,
              }}
            ></div>
            <WaterSewerInfo
              water={props.w}
              changeWater={props.changeWater}
              index={props.waterIndex}
              propertyInfo={props.propertyInfo}
            />
          </>
        )}
      </div>
    </React.Fragment>
  );
};
